import { FakDokumentStavkaView } from "../fak-dokument-stavka-view";

export class FakDokumentStavkaIzvozView extends FakDokumentStavkaView
{
    constructor(){
        super();
    }
    
    CenaUValuti: number = null;
    RabatVredUValuti: number = null;
    OsnovicaUValuti: number = null;
    OsnovicaStavkeUValuti: number = null;

    Deserialize(input: any){
        super.Deserialize(input);
        this.CenaUValuti = input.CenaUValuti;
        this.RabatVredUValuti = input.RabatVredUValuti;
        this.OsnovicaUValuti = input.OsnovicaUValuti;
        this.OsnovicaStavkeUValuti = input.OsnovicaStavkeUValuti;
        return this;
    }

    Serialize(input: FakDokumentStavkaIzvozView){
        return input;
    }
}